<template>
    <div class="models_container">
        <h1 style="margin-bottom: 20px;">Criar Voucher</h1>


        <div class="models">
            <v-row>
                <v-col cols="12" md="4" sm="6" v-for="model in models" :key="model._id">
                    <v-card>
                        <v-card-title>{{ model.title }}</v-card-title>
                        <v-card-subtitle>{{ model.description }}</v-card-subtitle>

                        <v-card-text class="model-preview-container">
                            <v-img contain class="model-preview" :src="model.image"></v-img>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn depressed block large color="primary" @click.native="create(model._id)">
                                Criar voucher
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
  
<script>
import Api from "@/lib/Api";

export default {
    name: "ListModelsView",

    data() {
        return {
            models: []
        };
    },

    async mounted() {
        const resp = await Api.getModels();
        if (resp && resp.models) this.models = resp.models;
    },

    methods: {
        create(model_id) {
            this.$router.push(`/criar-voucher/${model_id}`);
        }
    },
};
</script>
  
<style scoped>
.model-preview-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.model-preview {
    max-width: 200px;
    max-height: 200px;
}
</style>
  